import { render, staticRenderFns } from "./vav.vue?vue&type=template&id=6ddbb74c&"
import script from "./vav.vue?vue&type=script&lang=js&"
export * from "./vav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports